module.exports = __webpack_public_path__ + "static/img/8h.a1e435f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/8h.svg
// module id = 4048
// module chunks = 1